export default __webpack_public_path__ + "static/media/African-Nigerian-Couple-Love-Lovrican.9cc900bb.webp";